import { render, staticRenderFns } from "./newtest2.vue?vue&type=template&id=b3869d1e"
import script from "./newtest2.vue?vue&type=script&lang=js"
export * from "./newtest2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports